module.exports = __webpack_public_path__ + "img/cs5.6801eeb7.png";